import { IconButton, IconButtonProps, makeStyles } from '@material-ui/core';
import RefreshIcon from '@material-ui/icons/Refresh';
import clsx from 'clsx';
import React from 'react';
import styles from './styles';

const useStyles = makeStyles(styles);

export interface OwnProps extends IconButtonProps {
  onClick?: () => void;
  animate?: boolean;
}

const RefreshButton = ({
  onClick,
  animate = false,
  className,
  ...props
}: OwnProps) => {
  const classes = useStyles();

  return (
    <IconButton
      onClick={onClick}
      className={clsx(classes.root, { [classes.animated]: animate }, className)}
      data-testid="autosky-refreshbutton"
      {...props}
    >
      <RefreshIcon fontSize="small" />
    </IconButton>
  );
};

export default RefreshButton;
